import i18n from "i18next";
import { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Faq from "./components/Faq";
import "./i18n";
import MainLayout from "./MainLayout";
import BookingDetailsPage from "./pages/bookingDetails/BookingDetailsPage";
import CancelConfirm from "./pages/CancelConfirm/CancelConfirm";
import ConfirmationPage from "./pages/confirmation/ConfirmationPage";
import DynamicThanksMsg from "./pages/DynamicThanksMsg/DynamicThanksMsg";
import FormCancellationData from "./pages/FormCancellationData/FormCancellationData";
import InfoPage from "./pages/Info/InfoPage";
import LoginPage from "./pages/login/page";
import MyLmxThanksMsg from "./pages/MyLmxThanksMsg/MyLmxThanksMsg";
import SaveNewMidocoTask from "./pages/saveNewMidocoTask/SaveNewMidocoTask";
import UpgradesPage from "./pages/Upgrades/UpgradesPage";
import UploadFile from "./pages/uploadFile/UploadFile";
import UrgentRequest from "./pages/UrgentRequest/UrgentRequest";
import UrgentRequestConfirm from "./pages/UrgentRequestConfirm/UrgentRequestConfirm";
import { bookingActions } from "./redux/slices/bookingSlice";
import { setLogicChannel } from "./redux/slices/languageSlice";
import { useAppDispatch } from "./redux/store";
import ChatPage from "./pages/chat/page";
import AgencyInfoPage from "./pages/AgencyInfo/AgencyInfoPage";
import ConfirmEmailPage from "./pages/ConfirmEmail/ConfirmEmailPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminBookingPage from "./pages/admin/AdminBookingPage";
import AgencyLoginPage from "./pages/agency/AgencyLoginPage";
import AgencyMidocoPage from "./pages/agency/AgencyMidocoPage";

function App() {
  const dispatch = useAppDispatch();
  const cookie = sessionStorage.getItem("lmxBooking");

  useEffect(() => {
    try {
      if (cookie && cookie.length > 0) {
        const booking = JSON.parse(cookie);
        dispatch(bookingActions.setBookingData(booking));
      }
    } catch (e) {}

    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get("default-lang");
    const urlLogic = params.get("logic-chanel");

    if (urlLang || urlLogic) {
      if (urlLang) sessionStorage.setItem("mylmx-lang", urlLang);
      if (urlLogic) sessionStorage.setItem("mylmx-logic", urlLogic);
    }

    const logicChannel = sessionStorage.getItem("mylmx-logic");
    const currentLang = sessionStorage.getItem("mylmx-lang");

    if (logicChannel === "swiss") {
      if (
        !urlLang &&
        (!currentLang || (currentLang !== "fr" && currentLang !== "de"))
      ) {
        sessionStorage.setItem("mylmx-lang", "de");
      }
    } else if (!currentLang) {
      sessionStorage.setItem("mylmx-lang", "de");
    }

    const effectiveLang = sessionStorage.getItem("mylmx-lang") || "de";
    i18n.changeLanguage(effectiveLang);
  }, []);

  return (
    <Router basename={"/MyLmxApp"}>
      <MainLayout>
        <div className="App Mylmx">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/info" element={<InfoPage />} />
            <Route path="/booking-details" element={<BookingDetailsPage />} />
            <Route path="/urgentRequest" element={<UrgentRequest />} />
            <Route path="/umdconfirm" element={<UrgentRequestConfirm />} />
            <Route path="/cancelConfirm" element={<CancelConfirm />} />
            <Route
              path="/formCancellationData"
              element={<FormCancellationData />}
            />
            <Route path="/thanksMsg" element={<DynamicThanksMsg />} />
            <Route path="/welcomeMsg" element={<MyLmxThanksMsg />} />
            <Route path="/uploadfile" element={<UploadFile />} />
            <Route path="/saveNewMidocoTask" element={<SaveNewMidocoTask />} />
            <Route path="/upgrades" element={<UpgradesPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/agency-info" element={<AgencyInfoPage />} />
            <Route path="/confirm-email" element={<ConfirmEmailPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/booking" element={<AdminBookingPage />} />
            <Route path="/agency" element={<AgencyLoginPage />} />
            <Route path="/agency/dashboard" element={<AgencyMidocoPage />} />
          </Routes>
        </div>

        <div data-iframe-height></div>
      </MainLayout>
    </Router>
  );
}

export default App;
